import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/shared/shared.module";
import { teacherDescription, teacherSpecialty } from "../../data/teacher.data";
import { CommonModule } from "@angular/common";
import { DEMO } from "src/app/config/brand.config";

@Component({
  selector: "app-teacher",
  imports: [SharedModule, TranslateModule, CommonModule],
  templateUrl: "./teacher.component.html",
  styleUrl: "./teacher.component.scss",
})
export class TeacherComponent {
  teacherDescription = teacherDescription;

  teacherSpecializations = teacherSpecialty;

  readonly demo = DEMO;
}
